export function BookingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      style={{ stroke: 'none' }}
    >
      <rect fill="#003580" width="24" height="24" rx="3" style={{ stroke: 'none' }} />
      {/* "B" */}
      <path
        fill="#ffffff"
        style={{ stroke: 'none' }}
        d="M5.5 4h6.5c1.4 0 2.5.4 3.2 1.1.6.6.9 1.4.9 2.3 0 1.3-.7 2.2-1.7 2.7 1.4.5 2.2 1.6 2.2 3.1 0 1-.4 1.9-1.1 2.5-.8.7-2 1.1-3.5 1.1H5.5V4Zm6.3 5c.8 0 1.3-.5 1.3-1.2 0-.7-.5-1.1-1.3-1.1H8.5V9h3.3Zm.4 5.3c.9 0 1.5-.5 1.5-1.3s-.6-1.3-1.5-1.3H8.5v2.6h3.7Z"
      />
      {/* "." dot */}
      <circle fill="#ffffff" style={{ stroke: 'none' }} cx="19" cy="16.8" r="1.6" />
    </svg>
  );
}
